import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from '@driftt/tide-core'
import config from 'config'
import cx from 'classnames'
import { uninstallAppFromDrift } from 'api/developerApi'
import './style.css'


class AppInstalledView extends Component {

  static propTypes = {
    token: PropTypes.string,
    appId: PropTypes.string.isRequired,
    isInitializing: PropTypes.bool.isRequired,
    clearToken: PropTypes.func.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  state = {
    isUninstalling: false
  }

  uninstallApp = () => {
    const { appId, clearToken } = this.props

    const onDone = () => {
      this.setState({ isUninstalling: false }, clearToken)
    }
    const onError = (error) => {
      this.props.showErrorNotification('We couldn’t uninstall your app. Please try again.')
      this.setState({ isUninstalling: false })
    }
    const onStateSet = () => uninstallAppFromDrift(appId)
      .then(onDone)
      .catch(onError)

    this.setState({ isUninstalling: true }, onStateSet)
  }

  render() {
    const { token, isInitializing } = this.props
    const { isUninstalling } = this.state

    return (
      <div className="app-installed-view">
        <span className="page-title">
          Install App
        </span>
        <div className={cx({ 'app-installed-view-transparency': isInitializing })}>
          <span className="app-install-view-oauth-title">
            OAuth Tokens for Your Team
          </span>
          <p className="app-install-view-oauth-description">
            These tokens were automatically generated when you installed the app to your team. You can use these to authenticate your app.
          </p>
          <Input
            value={token}
            label="OAuth Access token"
            className={cx('app-install-view-token', {
              'drift-input-loaded': !!token
            })}
          />
          <p className="app-installed-view-info">
            Your app is now connected to your Drift account!
            <a href={`${config.CUSTOMER_WEB_URL}/settings2/integrations`} target="_blank" rel="noopener noreferrer">
              View your app in Drift.
            </a>
          </p>
          <Button
            className="app-installed-view-button"
            type="secondary"
            loading={isUninstalling}
            onClick={this.uninstallApp}>
            Remove App from Drift
          </Button>
        </div>
      </div>
    )
  }
}

export default AppInstalledView
